'use client'

import type { AccessTier } from '@/features/billing'
import { isDebugMode } from '@/lib/utils'

declare global {
  interface Window {
    fbq: (
      type: 'track' | 'trackCustom' | 'init',
      eventName: string,
      params?: Record<string, any>,
      options?: Record<string, any>,
    ) => void
  }
}

export type MetaPixelEvent =
  | 'PageView'
  | 'ViewContent'
  | 'Lead'
  | 'CompleteRegistration'
  | 'InitiateCheckout'
  | 'AddPaymentInfo'
  | 'Purchase'
  | 'Subscribe'
  | 'StartTrial'
  | 'Upgrade'

export type ContentCategory = 'film' | 'trailer' | 'bts'
export type PaymentProvider = 'stripe' | 'paypal'
export type DonationType = 'one-time' | 'monthly'

export interface MetaPixelParams {
  value?: number
  currency?: string
  content_category?: ContentCategory
  payment_provider?: PaymentProvider
  donation_type?: DonationType
  access_tier?: AccessTier
  em?: string
  [key: string]: any
}

export interface MetaPixelOptions {
  eventID?: string
}

export const pixel = (
  eventName: MetaPixelEvent,
  params?: MetaPixelParams,
  options?: MetaPixelOptions,
) => {
  if (isDebugMode()) {
    console.log(`🎯 ${eventName}`, params, options)
  }
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params || {}, options)
  }
}

export { TrackPageView } from '../components/track-page-view'
